import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { LangProvider } from "./contexts/LangContext";
import { AuthProvider } from "./contexts/AuthContext";
import PublicPage from "./components/PublicPage";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminEditor from "./pages/admin/AdminEditor";
import AdminSettings from "./pages/admin/AdminSettings";
import AdminSubmissions from "./pages/admin/AdminSubmissions";
import RequireAuth from "./components/RequireAuth";
import "@/App.css";

function App() {
  return (
    <BrowserRouter>
      <LangProvider>
        <AuthProvider>
          <Routes>
            {/* Public site */}
            <Route path="/" element={<PublicPage page="home" />} />
            <Route path="/about" element={<PublicPage page="about" />} />
            <Route path="/services" element={<PublicPage page="services" />} />
            <Route path="/services/sales" element={<PublicPage page="svc-sales" />} />
            <Route path="/services/logistics" element={<PublicPage page="svc-logistics" />} />
            <Route path="/services/data-analysis" element={<PublicPage page="svc-data-analysis" />} />
            <Route path="/services/support" element={<PublicPage page="svc-support" />} />
            <Route path="/services/credit" element={<PublicPage page="svc-credit" />} />
            <Route path="/thank-you" element={<PublicPage page="thank-you" />} />
            <Route path="/gracias" element={<PublicPage page="thank-you" />} />
            <Route path="/demos" element={<PublicPage page="demos" />} />
            <Route path="/contact" element={<PublicPage page="contact" />} />
            <Route path="/terms" element={<PublicPage page="terms" />} />
            <Route path="/privacy" element={<PublicPage page="privacy" />} />

            {/* Admin */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <RequireAuth>
                  <AdminDashboard />
                </RequireAuth>
              }
            />
            <Route
              path="/admin/editor/:page"
              element={
                <RequireAuth>
                  <AdminEditor />
                </RequireAuth>
              }
            />
            <Route
              path="/admin/settings"
              element={
                <RequireAuth>
                  <AdminSettings />
                </RequireAuth>
              }
            />
            <Route
              path="/admin/submissions"
              element={
                <RequireAuth>
                  <AdminSubmissions />
                </RequireAuth>
              }
            />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </LangProvider>
    </BrowserRouter>
  );
}

export default App;
